/* ================================================== */
/*  MOBILE MENU
/* ================================================== */

function actionMenuBtn(){
	$('body').toggleClass('menu--open');
	$('body').find('.hamburger').toggleClass('hamburger--open');
}


$(document).ready(function(){

	// --- HAMBURGER --- //
	$('.menu--trigger').on('click keypress', function(e){

		if (e.type == 'keypress') {
	    if(e.which == 13 || e.which == 32) {
				actionMenuBtn();
	    }
		} else if (e.type == 'click') {
			actionMenuBtn();
		}

	});

});